import React from 'react';
import { PictureOutlined } from '@ant-design/icons';

/** 列表封面缩略图（接口给的是 640 宽版本），16:9 */
const ContentCover: React.FC<{ url: string | null }> = ({ url }) => (
    <div className="w-[72px] h-[40px] rounded overflow-hidden bg-gray-100 flex items-center justify-center">
        {url
            ? <img src={url} alt="" loading="lazy" className="w-full h-full object-cover" />
            : <PictureOutlined className="text-gray-300" />}
    </div>
);

export default ContentCover;
